module.exports = require("react-addons-update");